import {Box, Flex, Image, Text} from "@mantine/core";
import {IconMinus, IconPlus, IconTrash} from "@tabler/icons-react";
import ProductPlaceholderImage from '../../../../../assets/images/product_placeholder.png';


const _CartItem5 = ({component}) => {
    return (
        <Box
            mx={component?.customize_styles?.general_decoration?.margin_x}
            my={component?.customize_styles?.general_decoration?.margin_y}
            px={component?.customize_styles?.general_decoration?.padding_x}
            py={component?.customize_styles?.general_decoration?.padding_y}
            bg={component?.customize_styles?.general_decoration?.background_color}
            style={{
                boxShadow: `${component?.customize_styles?.general_decoration?.shadow_offset_x}px ${component?.customize_styles?.general_decoration?.shadow_offset_y}px ${component?.customize_styles?.general_decoration?.shadow_blur_radius}px ${component?.customize_styles?.general_decoration?.shadow_blur_radius}px #00000014`,
                borderRadius: `${component?.customize_styles?.general_decoration?.border_radius}px`,
                border: `${component?.customize_styles?.general_decoration?.border_width}px solid ${component?.customize_styles?.general_decoration?.border_color}`,
            }}
        >
            <Box
                mx={component?.customize_styles?.box_decoration?.margin_x}
                my={component?.customize_styles?.box_decoration?.margin_y}
                px={component?.customize_styles?.box_decoration?.padding_x}
                py={component?.customize_styles?.box_decoration?.padding_y}
                bg={component?.customize_styles?.box_decoration?.background_color}
                style={{
                    boxShadow: `${component?.customize_styles?.box_decoration?.shadow_offset_x}px -${component?.customize_styles?.box_decoration?.shadow_offset_y}px ${component?.customize_styles?.box_decoration?.shadow_blur_radius}px ${component?.customize_styles?.box_decoration?.shadow_blur_radius}px #00000014`,
                    borderRadius: `${component?.customize_styles?.box_decoration?.border_radius}px`,
                    border: `${component?.customize_styles?.box_decoration?.border_width}px solid ${component?.customize_styles?.box_decoration?.border_color}`,
                }}
            >
                <Flex align="center" justify="space-between">
                    <Flex align="center" gap="xs">
                        <Box
                            w={component?.customize_styles?.image_decoration?.width}
                            h={component?.customize_styles?.image_decoration?.height}
                            // bg={component?.customize_styles?.image_decoration?.color}
                            style={{
                                borderRadius: `${component?.customize_styles?.image_decoration?.radius}px`
                            }}
                        >
                            <Image
                                style={{ width: "100%", height: "100%" }}
                                src=""
                                fallbackSrc={ProductPlaceholderImage}
                                alt=""
                                radius={component?.customize_styles?.image_decoration?.radius}
                            />
                        </Box>

                        <Box>
                            <Text
                                lineClamp={1}
                                translate="yes"
                                c={component?.customize_styles?.name_text_decoration?.color}
                                fw={component?.customize_styles?.name_text_decoration?.font_weight}
                                fz={component?.customize_styles?.name_text_decoration?.font_size}
                                fs={component?.customize_styles?.name_text_decoration?.font_style}
                            >
                                Product Name
                            </Text>
                            <Text
                                lineClamp={1}
                                translate="yes"
                                c={component?.customize_styles?.product_category_text_decoration?.color}
                                fw={component?.customize_styles?.product_category_text_decoration?.font_weight}
                                fz={component?.customize_styles?.product_category_text_decoration?.font_size}
                                fs={component?.customize_styles?.product_category_text_decoration?.font_style}
                            >
                                Category
                            </Text>
                            <Text
                                mt={3}
                                fz={component?.customize_styles?.product_price_text_decoration?.font_size}
                                fw={component?.customize_styles?.product_price_text_decoration?.font_weight}
                                c={component?.customize_styles?.product_price_text_decoration?.color}
                                // bg={component?.customize_styles?.product_price_text_decoration?.background_color}
                                ta={component?.customize_styles?.product_price_text_decoration?.text_align}
                            >
                                $00.00
                            </Text>
                        </Box>
                    </Flex>
                    <Flex direction="column" gap={10}>
                        <Flex align="center" justify="flex-end" gap={2}>
                            <IconTrash size={25} color="#F13658" />
                        </Flex>
                        <Flex
                            align="center"
                            justify="flex-end"
                            gap={10}
                            bg="#F13658"
                            w={80}
                            px={5}
                            py={3}
                            style={{ borderRadius: "8px" }}
                        >
                            <IconMinus size={18} color="#ffffff" />
                            <Text fz={13} fw={600} c="#ffffff">4</Text>
                            <IconPlus size={18} color="#ffffff" />
                        </Flex>
                    </Flex>
                </Flex>
            </Box>
        </Box>
    )
}
export default _CartItem5;